import { Group, Paper, Stack, Text, rem } from '@mantine/core';
import { Outlet } from '@tanstack/react-router';
import { FC } from 'react';

import { ResultNav } from '../../components/result-nav';
import { ResultsClauseHelpContent } from '../../components/results-help/results-clause-help-content';
import { useResultPage } from '../../hooks/use-result-page';

import { FullMainHeight } from '@ui';

export const ResultPage: FC = () => {
  const { result } = useResultPage();
  const clause = result.data?.clause?.toLowerCase() === 'gp' ? 'gp' : 'new';

  return (
    <FullMainHeight.Root>
      <FullMainHeight.FlexContent>
        <FullMainHeight.Sidebar>
          <Stack h="100%">
            <Paper withBorder>
              <Stack gap={0} h={rem(36)}>
                <Text fw={600} lh={1} size="lg">
                  {result.data?.farm?.name}
                </Text>
                <Group gap="xs">
                  <Text size="sm">
                    {result.data?.account?.last_name}{' '}
                    {result.data?.account?.first_name}
                  </Text>
                </Group>
              </Stack>
            </Paper>
            <Paper p="md" style={{ display: 'flex', flex: 1, minHeight: 0 }} withBorder>
              <Stack
                style={{
                  flex: 1,
                  minHeight: 0,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  scrollbarGutter: 'stable',
                }}
              >
                <ResultsClauseHelpContent
                  clause={clause}
                  showClauseLabel
                  variant="full"
                />
              </Stack>
            </Paper>
          </Stack>
        </FullMainHeight.Sidebar>
        <Stack h="100%" style={{ overflow: 'hidden' }}>
          <Paper flex="0 0 auto" withBorder>
            <ResultNav />
          </Paper>
          <Outlet />
        </Stack>
      </FullMainHeight.FlexContent>
    </FullMainHeight.Root>
  );
};
